<template>
    <div class="card">
        <div class="card-modal" style="overflow:auto;max-height:700px;">
            <div v-if="loading">
                <b-loading :is-full-page="true" v-model="loading" :can-cancel="false"></b-loading>
            </div>
            <header class="modal-card-head">
                <p class="modal-card-title">Update Credit Card</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <b-field label="Display Name">
                    {{ card.displayName }}
                </b-field>
                <b-field label="Name on Card">
                    {{ card.nameOnCard }}
                </b-field>
                <b-field label="Card Brand / Last4">
                    {{ card.brand }} •••• {{ card.last4 }}
                </b-field>

                <creditCardExpirationInput v-model="expDate" />

                <div class="mt-4 mb-2" v-if="hasError">
                    <b-notification type="is-danger" v-model="hasError" aria-close-label="Close notification">
                        {{ errorMessage }}
                    </b-notification>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button label="Close" @click="close" />
                <b-button :disabled="disabled" class="is-pulled-right" label="Save" type="is-primary" @click="submit" />
            </footer>
        </div>
    </div>
</template>

<script>
import creditCardExpirationInput from './creditCardExpirationInput'

export default {
    name: 'UpdateCardModal',
    components: {
        creditCardExpirationInput
    },
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            expDate: {
                month: "",
                year: ""
            },
            hasError: false,
            errorMessage: "",
            loading: false
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.hasError = false;
            var body = {
                "id": this.card.id,
                "contactId": this.$globals.travellerProfile.id,
                "nameOnCard": this.card.nameOnCard,
                "brand": this.card.brand,
                "displayName": this.card.displayName,
                "expirationMonth": this.expDate.month.toString(),
                "expirationYear": this.expDate.year.toString(),
            }
            this.$app.huddleLabsServerCall('profile/payment-methods/update', body)
                .then(result => {
                    if (result.data) {
                        this.initUpdateAction(result.data);
                    } else {
                        this.errorMessage = "Error updating payment method";
                        this.hasError = true;
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.errorMessage = "Error updating payment method " + error;
                    this.hasError = true;
                    this.loading = false;
                });
        },
        initUpdateAction(val) {
            this.$store.dispatch("travellersAndTrips/updatePayment", val).then(() => {

                if (!this.pathMixin_isMeeting) {
                    return this.$store.dispatch("bookTravel/updatePersonalPaymentMethod", val);
                }
                return Promise.resolve();
            }).then(() => {
                // Once both actions are complete, set the payment method if useMultiplePaymentMethods is false
                this.close();
            }).catch(error => {

                this.errorMessage = "Error updating payment method " + error;
                this.hasError = true;
                this.loading = false;
            });

        },
        close() {
            this.hasError = false;
            this.$emit('close');
        }
    },
    computed: {
        disabled() {
            if (!(this.expDate)) {
                return true;
            } else {
                return false;
            }
        },
    }
}

</script>


<style scoped></style>